import {
  GridRenderCellParams,
  GridRenderHeaderFilterProps,
} from '@mui/x-data-grid-pro';
import ArrCheckbox from '../../../../common/arr-checkbox/ArrCheckbox';
import FilterTextField from '../../../../common/arr-data-grid-pro/filter-components/text-field/FilterTextField';
import {t} from 'i18next';
import {Typography} from '@mui/material';

export const columns = ({
  rows,
  selectedRows,
  setSelectedRows,
}: {
  rows: any[];
  selectedRows: string[];
  setSelectedRows: (ids: string[] | ((prev: string[]) => string[])) => void;
}) => [
  {
    field: 'select',
    headerName: '',
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    valueGetter: () => null,
    width: 40,
    headerClassName: 'custom-select-column',
    cellClassName: 'custom-select-column',
    renderHeader: () => {
      const allRowIds = rows.filter((r) => !r.isFilterRow).map((r) => r.id);

      const isAllSelected =
        allRowIds.length > 0 &&
        allRowIds.every((id) => selectedRows.includes(id));

      const isIndeterminate =
        selectedRows.length > 0 && selectedRows.length < allRowIds.length;

      return (
        <ArrCheckbox
          inputProps={{
            'aria-label': `${t('common.arrDataGridPro.checkbox.selectAll')}`,
            tabIndex: 0,
          }}
          checked={isAllSelected}
          isIndeterminate={isIndeterminate}
          onChange={() => setSelectedRows(isAllSelected ? [] : allRowIds)}
          size="small"
          aria-label={`select-all-header-checkbox`}
        />
      );
    },

    renderCell: (params: GridRenderCellParams) => {
      if (params.row.isFilterRow) return null;

      const isChecked = selectedRows.includes(params.row.id);

      return (
        <ArrCheckbox
          checked={isChecked}
          size="small"
          aria-label={`${params.id}-checkbox`}
          onChange={() => {
            setSelectedRows((prev) =>
              isChecked
                ? prev.filter((id) => id !== params.row.id)
                : [...prev, params.row.id]
            );
          }}
        />
      );
    },
  },
  {
    field: 'docId',
    headerName: '',
    filterable: false,
    sortable: false,
    cellClassName: 'typo-text subhead5_size',
    width: 160,
    renderHeader: () => (
      <Typography
        className="typo-text label2_size"
        tabIndex={0}
        role="columnheader"
        data-testid={`doc-error-panel-data-doc-id-header`}
      >
        {t('ai.review.jobErrorPanel.docId')}
      </Typography>
    ),

    renderCell: (params: GridRenderCellParams) => {
      if (params.row.isFilterRow) return null;

      const isClickable = !!params.row.docId;

      return (
        <Typography
          tabIndex={0}
          className={`typo-text subhead5_size ${isClickable ? 'docIdClickable' : 'docIdNonClickable'}`}
          onClick={(e) => {
            if (isClickable) {
              e.stopPropagation();
              console.log('Clicked docId:', params.value);
            }
          }}
          data-testid={`doc-error-panel-docId-${params.id}`}
        >
          {params.value}
        </Typography>
      );
    },
  },
  {
    field: 'errorMessage',
    headerName: `${t('ai.review.jobErrorPanel.errorMessage')}`,
    flex: 3,
    cellClassName: 'typo-text body3_size',
    sortable: false,
    filterable: true,
    renderHeader: () => (
      <Typography
        className="typo-text label2_size"
        tabIndex={0}
        role="columnheader"
        data-testid={`doc-error-panel-data-error-message-header`}
      >
        {t('ai.review.jobErrorPanel.errorMessage')}
      </Typography>
    ),
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Typography
          className="cell-content typo-text body3_size"
          tabIndex={0}
          role="gridcell"
          data-testid={`doc-error-panel-data-err-message-${params.id}`}
        >
          {params.value}
        </Typography>
      );
    },
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          dataTestId={`errorMessage`}
          gridRenderHeaderFilterProps={params}
          placeholder={t('common.filter')}
          className="custom-filter"
        />
      );
    },
  },
];
